let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i3DnP")).then(() => parcelRequire('3vVaC'));